import React from 'react';
import SEO, { SITE_URL, defaultOrganizationSchema } from '../../components/SEO';
import RecentlyViewedStrip from './components/RecentlyViewedStrip';
import HeroSection from './components/HeroSection';
import SearchSection from './components/SearchSection';
import InteractiveMapPreview from './components/InteractiveMapPreview';
import SuccessMetrics from './components/SuccessMetrics';
import FeatureGrid from './components/FeatureGrid';
import TrustSignals from './components/TrustSignals';
import TenantTestimonials from './components/TenantTestimonials';
import AppDownloadSection from './components/AppDownloadSection';

const Homepage = () => {
  return (
    <div className="min-h-screen bg-white pt-16">
      <SEO
        canonical="/"
        description="Toletforrent — India's zero-brokerage rental marketplace. Find verified rooms, PGs, flats, houses and commercial spaces directly from owners across 100+ cities. No brokerage, no hidden charges."
        keywords="rent house, flat for rent, PG, room for rent, commercial space for rent, no brokerage rentals, rental marketplace India, Toletforrent"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'Toletforrent',
            url: SITE_URL,
            potentialAction: {
              '@type': 'SearchAction',
              target: `${SITE_URL}/advanced-search-discovery?q={search_term_string}`,
              'query-input': 'required name=search_term_string',
            },
          },
          defaultOrganizationSchema,
        ]}
      />
      <RecentlyViewedStrip />
      <HeroSection />
      <SearchSection />
      <InteractiveMapPreview />
      <SuccessMetrics />
      <FeatureGrid />
      <TrustSignals />
      <TenantTestimonials />
      <AppDownloadSection />
    </div>
  );
};

export default Homepage;
